.toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: var(--tempest-space-2);
    border: 1px solid transparent;
    border-radius: var(--tempest-radius-md);
    background-color: var(--tempest-surface);
    color: var(--tempest-text);
    font-family: var(--tempest-font-sans);
    font-weight: var(--tempest-weight-medium);
    line-height: var(--tempest-leading-snug);
    cursor: pointer;
    transition:
        var(--tempest-transition-color),
        background-color var(--tempest-duration-base) var(--tempest-ease-emphasized);
    white-space: nowrap;
}

@media (hover: hover) and (pointer: fine) {
    .toggle:hover {
        background-color: var(--tempest-surface-2);
    }
}

.toggle:focus-visible {
    outline: var(--tempest-focus-ring-width) solid var(--tempest-focus-ring-color);
    outline-offset: 2px;
}

.toggle:disabled {
    opacity: 0.55;
    cursor: not-allowed;
}

.outline {
    background-color: transparent;
    border-color: var(--tempest-border);
}

.pressed {
    background-color: var(--tempest-primary-soft);
    color: var(--tempest-primary-on-soft);
    border-color: var(--tempest-primary-soft);
}

.outline.pressed {
    border-color: var(--tempest-primary);
}

@media (hover: hover) and (pointer: fine) {
    .pressed:hover {
        background-color: var(--tempest-primary-soft-hover, var(--tempest-primary-soft));
    }
}

.sm {
    min-height: 1.75rem;
    padding: 0 var(--tempest-space-2);
    font-size: var(--tempest-text-xs);
}

.md {
    min-height: 2.25rem;
    padding: 0 var(--tempest-space-3);
    font-size: var(--tempest-text-sm);
}

.lg {
    min-height: 2.75rem;
    padding: 0 var(--tempest-space-4);
    font-size: var(--tempest-text-base);
}
